/**
 * iter87.199.112 — Standalone /terms route.
 *
 * The general TCR Terms of Use lived only inside TermsModal on the
 * marketing landing. iter87.199.111's footer linked `/terms` to a
 * non-existent route (empty page on prod). This standalone page
 * renders the same TERMS_BODY at a real URL so the footer link
 * lands somewhere.
 *
 * iter87.199.144 — Switched to the shared `renderMarkdownBody`
 * renderer (proper bold/link markdown parsing + multi-line bullet
 * joining) so this page visually and structurally matches `/privacy`
 * and `/terms/pro-plus-billing`.
 */
import { TERMS_BODY, TERMS_VERSION } from "@/lib/terms";
import { renderMarkdownBody } from "@/lib/simpleMarkdown";

export default function TermsPage() {
    return (
        <div
            className="min-h-screen bg-[#0a0a0a] text-white px-4 py-8"
            data-testid="terms-page"
        >
            <div className="max-w-2xl mx-auto space-y-4">
                <p className="text-white/50 text-xs uppercase tracking-widest mb-4" data-testid="terms-page-version">
                    Version {TERMS_VERSION}
                </p>
                {renderMarkdownBody(TERMS_BODY)}
            </div>
        </div>
    );
}
